<script>
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model(value) {
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

                // console.log("selected ", selectedItem)
                if (this.field.key == 'accountInfo.stockDividendId') {
                    if (
                        selectedItem.dataSegmentId ==
                        process.env.VUE_APP_RC_ACCOUNT
                    ) {
                        this.$store.commit('updateField', {
                        key: 'regAccInfo.dividendInstruction',
                        value: selectedItem.value,
                    })
                    } else {

                        this.$store.commit('updateField', {
                            key: 'asaanAccInfo.dividendInstruction',
                            value: selectedItem.value,
                        })
                    }
                   this.$store.commit('updateField', {
                        key: 'accountInfo.stockDividend',
                        value: selectedItem.title,
                    })
                    
                }
            }
        },
    }, // End of Component > watch
}
</script>
